import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOn = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 15,
	viewBox: "0 0 18 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.5 7.5013C16.5 9.16797 13.5833 13.3346 9 13.3346C4.41667 13.3346 1.5 9.16797 1.5 7.5013C1.5 5.83464 4.41667 1.66797 9 1.66797C13.5833 1.66797 16.5 5.83464 16.5 7.5013Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.5 7.5013C11.5 8.88201 10.3807 10.0013 9 10.0013C7.61929 10.0013 6.5 8.88201 6.5 7.5013C6.5 6.12059 7.61929 5.0013 9 5.0013C10.3807 5.0013 11.5 6.12059 11.5 7.5013Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgEyeOn);
export default ForwardRef;
